import React from 'react';

const HistoryIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.97 14.95L9.00002 11.87V5H11V10.76L15.03 13.25L13.97 14.95ZM21 10C21 15.51 16.51 20 11 20C5.49002 20 1.00002 15.51 1.00002 10H2.00002C2.00002 14.96 6.04002 19 11 19C15.96 19 20 14.96 20 10C20 5.04 15.96 1 11 1C7.81002 1 4.92002 2.64 3.28002 5.38C3.17002 5.56 3.06002 5.75 2.97002 5.94C2.96002 5.96 2.95002 5.98 2.94002 6H7.00002V7H0.960022V1H1.96002V5.74C2.00002 5.65 2.03002 5.57 2.07002 5.49C2.18002 5.27 2.30002 5.07 2.42002 4.86C4.22002 1.86 7.51002 0 11 0C16.51 0 21 4.49 21 10Z"
        fill="black"
      />
    </svg>
  );
};

export default HistoryIcon;
